<template>
<div>
    <md-card v-if="isVisible">
        <header-form title="LOCALIZAR CLIENTE" :btnHide="true" />

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.cpf_cnpj }">
                        <label>CPF OU CNPJ:</label>
                        <md-input v-model="dados.cpf_cnpj" type="text" class="pagamento" v-mask="['###.###.###-##', '##.###.###/####-##']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.cpf_cnpj">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.cpf_cnpj" class="validErro"> {{ errors.cpf_cnpj[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-button @click="getCliente" class="md-site md-round md-block">
                        <span class="md-label">
                            <md-icon class="material-icons">search</md-icon>
                        </span>BUSCAR
                    </md-button>
                </div>
            </div>
            <div v-if="message" class="alert alert-danger" style="padding: 1px 15px">
                <h4> {{message}} </h4>
            </div>
        </md-card-content>
    </md-card>

    <md-card v-if="!isVisible">
        <header-form @click.native="isVisible = true" title="CADASTRAR PARCELAMENTO" tooltip="Voltar" icon="fas fa-arrow-left" />

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-40 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>NOME:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.nome }}</strong></h4>
                </div>

                <div class="md-layout-item md-size-45 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>EMPRESA:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.empresa }}</strong></h4>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>LIMITE:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.limite | moeda }}</strong></h4>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.valor }">
                        <label>VALOR</label>
                        <md-input v-model="dados.valor" type="text" class="pagamento" v-money> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.valor">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.valor" class="validErro"> {{ errors.valor[0] }}</div>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.parcelas }">
                        <label>PARCELAS</label>
                        <md-select v-model="dados.parcelas" name="pages">
                            <md-option v-for="item in parcelas" :key="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.parcelas">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.parcelas" class="validErro"> {{ errors.parcelas[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-datepicker v-model="dados.vencimento" md-immediately v-mask="'##/##/####'">
                        <label>Vencimento</label>
                    </md-datepicker>
                </div>

                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-autocomplete :class="{ 'md-error': errors.fornecedor_id }" v-model="fornecedor" :md-options="fornecedores" @md-changed="autoCompleteFornecedor" @md-opened="autoCompleteFornecedor" @md-selected="getSelectedFornecedor">
                        <label>FORNECEDOR</label>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.fornecedor_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-autocomplete>
                    <div v-if="errors.fornecedor_id" class="validErro"> {{ errors.fornecedor_id[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-button @click="create" class="md-success md-round md-block">
                        <span class="md-label">
                            <md-icon class="material-icons">shopping_basket</md-icon>
                        </span>GERAR PARCELAS
                    </md-button>
                </div>
            </div>
        </md-card-content>
    </md-card>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';
import Pagamento from '@/config/mixins/print/pagamento'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {
                parcelas: 1,
            },
            cliente: {
                limite: 0
            },
            listFornecedores: [],
            fornecedores: ['X'],
            fornecedor: '',
            parcelas: [],
            message: null,
            errors: {},
            isVisible: true
        }
    },

    created() {
        this.numParcelas();
        this.getList();
    },

    mixins: [Notify, preLoader, Pagamento],

    watch: {
        fornecedor: function (value) {
            if (value == null || value == '') {
                this.dados.fornecedor_id = null
            }
        },
    },

    methods: {
        getList() {
            this.$http.get(this.$urlAPI + 'parcelamentos')
                .then(response => {
                    this.listFornecedores = response.data.dados.fornecedores
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        autoCompleteFornecedor(searchTerm) {
            this.fornecedores = new Promise(resolve => {
                if (!searchTerm) {
                    resolve(this.listFornecedores.map(x => x.name));
                } else {
                    const term = searchTerm.toLowerCase();
                    this.fornecedores = this.listFornecedores.filter(({
                        name
                    }) => {
                        return name.toLowerCase().includes(term);
                    }).map(x => x.name);
                    resolve(this.fornecedores);
                }
            });
        },

        getSelectedFornecedor() {
            let customer = this.fornecedor
            this.dados.fornecedor_id = this.listFornecedores.filter(function (e) {
                return e.name === customer
            })[0].id
        },

        getCliente() {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'pagamentos/buscar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.cliente = response.data.dados[0];
                        this.errors = ''
                        this.message = null
                        this.isVisible = false
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message;
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        numParcelas() {
            let parcelas = []
            for (let i = 1; i < 36 + 1; i++) {
                parcelas.push(i);
            }
            this.parcelas = parcelas;
        },

        create() {
            this.dados.cliente_id = this.cliente.id;
            this.dados.empresa_id = this.cliente.empresa_id;
            this.$http.post(this.$urlAPI + 'parcelamentos', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.dados = response.data.dados
                        this.$router.push({
                            name: 'parcelamentosRead',
                            params: {
                                id: this.dados.id
                            }
                        })
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>

<style>
.text-label {
    margin-top: -25px !important;
}

.md-toggle-password,
.error {
    visibility: hidden !important;
}
</style>
